import { SET_JOBS_QUEUE } from "../actions/actionTypes";

const INITIAL_STATE = {
  jobs: []
};

export const jobsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_JOBS_QUEUE:
      return {
        ...state,
        jobs: action.payload
      };
    default:
      return state;
  }
};
